export default class Tooltip {
    constructor(BootstrapTooltip) {
        this.BootstrapTooltip = BootstrapTooltip;
        this.init();
    }

    init() {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(tooltipTriggerEl => {
            return new this.BootstrapTooltip(tooltipTriggerEl);
        });
    }
}